import { render, staticRenderFns } from "./YandexMap.vue?vue&type=template&id=45f5a2fc&scoped=true"
import script from "./YandexMap.vue?vue&type=script&lang=js"
export * from "./YandexMap.vue?vue&type=script&lang=js"
import style0 from "./YandexMap.vue?vue&type=style&index=0&id=45f5a2fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f5a2fc",
  null
  
)

export default component.exports